import type { DesignProof, DesignRequestOrientation } from '@ghostscreen/contracts';

type DesignProofPreviewProps = {
  proof: DesignProof;
  orientation: DesignRequestOrientation;
  brand: string;
  photoUrl: string | null;
};

export function DesignProofPreview({
  proof,
  orientation,
  brand,
  photoUrl,
}: DesignProofPreviewProps) {
  const portrait = orientation === 'portrait';
  const hasPhoto = Boolean(photoUrl);

  return (
    <div
      className="overflow-hidden rounded-[10px] border-[6px] border-[#0b0b0d]"
      style={{
        width: portrait ? 'min(100%, 240px)' : '100%',
        margin: portrait ? '0 auto' : undefined,
        aspectRatio: portrait ? '9 / 16' : '16 / 9',
        display: 'grid',
        gridTemplateColumns: !portrait && hasPhoto ? '1.15fr 1fr' : '1fr',
        gridTemplateRows: portrait && hasPhoto ? '1fr 0.8fr' : '1fr',
        background: proof.bg,
        color: proof.fg,
        boxSizing: 'border-box',
      }}
    >
      <div className="flex min-w-0 flex-col justify-center gap-3 p-[7%]">
        <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] opacity-75">
          {brand}
        </span>
        <span className="text-[30px] font-extrabold leading-[1.05] tracking-[-0.03em]">
          {proof.head}
        </span>
        {proof.lines.map((line) => (
          <span
            key={`${line.name}-${line.price}`}
            className="flex justify-between gap-3 border-b border-current pb-1.5 text-sm font-semibold"
          >
            <span>{line.name}</span>
            <span className="font-extrabold">{line.price}</span>
          </span>
        ))}
        {proof.sub ? (
          <span className="text-[13.5px] leading-[1.4] opacity-85">{proof.sub}</span>
        ) : null}
      </div>
      {hasPhoto ? (
        <img src={photoUrl!} alt="" className="block h-full min-h-0 w-full object-cover" />
      ) : null}
    </div>
  );
}
